import { Book } from './Book'
import { TemplatePrintInfo } from './PrintInfo'

class Template extends Book {
  name
  author
  description
  tags
  coverUrl
  printInfo
  available
  preview
  examples
  price
  cssVariables

  constructor (ref, data, sheets) {
    super(ref, sheets)

    this.name = data.name
    this.author = data.author
    this.description = data.description
    this.tags = data.tags
    this.coverUrl = data.coverUrl
    this.printInfo = new TemplatePrintInfo(data.printInfo)
    this.available = data.available ?? false
    this.preview = data.preview && data.preview.length > 0 ? data.preview : [data.coverUrl]
    this.examples = data.examples || []
    this.price = data.price ?? 0
    this.cssVariables = data.cssVariables ?? []
    this.defaultSheets = data.defaultSheets || []
  }

  toObject () {
    const data = super.toObject()
    data.printInfo = data.printInfo.toObject()
    data.defaultSheets = JSON.parse(JSON.stringify(this.defaultSheets || []))
    delete data.sheets
    return data
  }
}

export { Template }
